export default "__VITE_ASSET__BWsYwA3X__"